import React from "react";
import { ShieldAlert } from "lucide-react";

interface PermissionRequiredModalProps {
  open: boolean;
  onClose: () => void;
  requiredPermission: string;
}

const PermissionRequiredModal: React.FC<PermissionRequiredModalProps> = ({
  open,
  onClose,
  requiredPermission,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-xl w-[490px] p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-red-100 text-red-600 p-2 rounded-full flex items-center justify-center">
            <ShieldAlert className="w-5 h-5" />
          </div>
          <h2 className="text-lg font-semibold">Permission Required</h2>
        </div>

        <p className="text-gray-600 mb-3">
          You don't have permission to access this feature.
        </p>

        <p className="mb-3">
          Required permission:{" "}
          <span className="text-red-500 font-medium">{requiredPermission}</span>
        </p>

        <p className="text-gray-500 text-sm mb-6">
          Please contact your administrator to request access to this feature.
        </p>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-black text-white rounded-lg"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default PermissionRequiredModal;
